
export interface FileSelectMessage {
  dropFilesHere: string;
  select: string;
  invalidFileExtension: string;
  invalidMaxFileSize?: string;
  invalidMinFileSize?: string;
  remove?: string;
}

export enum FileSelectLabels {
  noFileChoosen = 'No file chosen.',
  selectFile = 'Select file',
  fileTypeNotAllowed = 'File type not allowed.',
  documentRequired = 'Document is required - use the Browse button to select one for upload.',
  attachments = 'Attachments',
  downloadDocSuccess = 'Downloaded successfully',
  downloadDocFail = 'Download failed',
  emptyLabel = '',
  fileNotFound = "No Document found",
  xmlDocumentRequired = 'REQUIRED FIELD',
  onlyXMLDocumentRequired = 'Allow only XML file',
  SuccessMessage = 'XML File Uploaded Successfully!',
  fileSizeTooLarge = 'File is too large.'
}
